import { render, staticRenderFns } from "./OpenTaskFilters.vue?vue&type=template&id=0f0a19d6"
import script from "./OpenTaskFilters.vue?vue&type=script&lang=js"
export * from "./OpenTaskFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports